<template>
    <div class="thesis">
      <template  >
        <SystemUpdating/>
      </template>
      <template style="display: none">
        <div class="thesis-content" >
            <ul >
                <li v-for="(item,index) in data.paperRespList" :key="index">
                    <span>{{item.paperType}}:</span><span class="number">{{item.paperCount}}篇</span>
                </li>
            </ul>

        </div>
      </template>
    </div>

</template>

<script>
  import SystemUpdating from "./SystemUpdating"
  import GoMore from "./GoMore";
    export default {
        name: "Thesis",
        props: {
            data:  { type: Object, default:()=>{}},
        },
      components: {
        GoMore,
        SystemUpdating
      },
    }
</script>

<style scoped lang="scss">
    .thesis {
        height: 253px;
        background-color: #E8EAF3;
        &-content {
            padding:  30px 50px 0 50px;
            ul {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                li {
                    font-size: 14px;
                    color:#3A3550;
                    line-height: 24px;
                    margin-bottom: 30px;
                   width: 49%;
                    text-align: center;
                    span {
                        display: inline-block;
                        width: 49%;
                        span:nth-child(1) {
                            text-align: right;
                            border:1px solid red;
                        }
                        span:nth-child(2) {
                            text-align: right;
                            border:1px solid red;

                        }
                    }
                    .number {
                        font-size: 24px;
                    }
                }

            }
            .noData {
                width: 100%;
            }
        }

    }
    @media (max-width: 1719px){
        .thesis-content {
            padding:  30px 30px 0 30px;
        }

    }

</style>